<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch,computed } from 'vue'
import CustomList from "../../../../compositions/CustomList.vue";
import ModalDialog from "../../../../compositions/ModalDialog.vue";
import SearchBox from "../../../../compositions/SearchBox.vue";
import OrderMedicineComponent from '../../../Common/OrderMedicineComponent.vue';
import config from "../../../../config.js";
import { errorAlert,confirmAlert } from "../../../../plugins/alert";
import { getFieldValue } from "../../../../plugins/utility";
import qs from 'qs';
import axios from '../../../../plugins/axios.ts';
import { useOrderStore } from '../../../../stores/order';
import HelpAction from '../../../../compositions/HelpAction.vue';

const order = useOrderStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    pharmacyWholesalers:{
      type:Array,
      required:true,
    },
    identityId: {
      typ:Number,
      default:() => {
        return 0;
      }
    },
    isVisible:{
        type:Boolean,
        default: () => {
            return false;
        }
    }
})

const { isVisible,identityId } = toRefs(props);
const listHeight = ref(65);
const listOrderDefectRef = ref();
const submitRef = ref();
const headerRef = ref();
const checkList = ref([]);
const changeListHeight = () => {
  if (typeof headerRef.value !== 'undefined') {
    listHeight.value = window.innerHeight - document.getElementById('header').clientHeight - document.getElementById('footer').clientHeight - document.getElementById('order_header').clientHeight - headerRef.value.clientHeight - 5;
    if (typeof submitRef.value !== 'undefined' && isEditedCheck()) {
      listHeight.value -= (submitRef.value.clientHeight - document.getElementById('footer').clientHeight - 5);
    }
    if (listHeight.value < 200) {
      listHeight.value = 200;
    }
  }
}

const searchWord = ref('');
const handler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
  }
}
const orderFields = ref([
  {field_name: '採用品', field_key: 'product_detail_name', width: '20%', align: 'text-left', sorted:true},
  {field_name: '', field_key: 'order_target_type', width: '6%', align: 'text-center'},
  {field_name: '伝票情報', field_key: 'slip_info', width: '15%', align: 'text-left'},
  {field_name: '発注先', field_key: 'order_target', width: '10%', align: 'text-left'},
  {field_name: '納品日', field_key: 'delivery_date', width: '10%', align: 'text-center', sorted:true},
  {field_name: '', field_key: 'defected_number', width: '50%', align: 'text-center'},
]);
const orderOptionFields = reactive({
  'search_word' : searchWord.value,
  'page_size' : 30,
  'is_defect' : 1
});
const listSearch = (force = false,delay=0) => {
  orderOptionFields.search_word = searchWord.value;
  if (force == false) {
    listOrderDefectRef.value.resetItem(delay);
  } else {
    listOrderDefectRef.value.resetForceItem(delay);
  }
}
const onSearchWordChange = (value) => {
  searchWord.value = value;
}
const onSearchWordEnter = (value) => {
  searchWord.value = value;
  listSearch();
}
const editSettingComplete = () => {
  listSearch(false,config.LIST_DELAY);
}
const editTransactionStatusChange = (identityId,status,reserveCount) => {
  let item = listOrderDefectRef.value.getItemById(identityId,'id');
  if (reserveCount == 0) {
    if (checkList.value.indexOf(item.id) != -1) {
      checkList.value.splice(checkList.value.indexOf(item.id),1);
    }
    listOrderDefectRef.value.deleteItem(item);
    order.order_defect_count--;
  }
}
const isLoadingDialog = ref(false);
const updatePharmacyDefectConfirm = async (reverse=false) => {
  let result = await confirmAlert((reverse == false ? '実行すると元に戻せません。返品処理を確定しますか？' : '納品待ちに戻しますか？'));
  if (result.isConfirmed) {
    await updatePharmacyDefect(reverse)
  }
}
const updatePharmacyDefect = async (reverse=false) => {
  let params = new FormData();
  for (let i=0;i<checkList.value.length;i++) {
    let item = listOrderDefectRef.value.getItemById(checkList.value[i]);
    for (let j=0;j<item.pharmacy_defects.length;j++) {
      params.append('defect_ids', item.pharmacy_defects[j].id);
    }
  }
  params.append('reverse', (reverse == false ? 0 : 1));
  isLoadingDialog.value = true;
  try {
    const response = await axios(props.apis.pharmacy_stock_update_transaction_status,{method:"post",data:params});
    if (response.data.status == 200) {
      if (reverse) {
        order.order_wait_count += response.data.data;
      }
      checkList.value.splice(0);
      listSearch(false,config.LIST_DELAY);
    } else {
      errorAlert(response.data.message);
    }
  } finally {
    isLoadingDialog.value = false;
  }
}

watch(isVisible,(newValue, oldValue) => {
  if (newValue) {
    listSearch();
  }
})
watch(identityId,(newValue, oldValue) => {
  listSearch(true);
})
const onCheckChange = (values) => {
  checkList.value = values;
}
const domComplete = () => {
  order.order_defect_count = listOrderDefectRef.value.getItemAllCount();
}
const isEditedCheck = () => {
  return (checkList.value.length > 0 ? true : false);
}
const isEdited = computed(() => {
  setTimeout(changeListHeight,100);
  return isEditedCheck();
});
onBeforeUnmount(() => {
  window.removeEventListener('resize', changeListHeight);
})
onMounted(() => {
  listSearch();
  window.addEventListener('resize', changeListHeight);
  setTimeout(changeListHeight,100);
});
</script>

<style scoped>
</style>
<template>
<div v-show="isVisible" class="relative">
  <div class="absolute top-2 left-2">
    <help-action
      help-key="order_defect_list_help"
    ></help-action>
  </div>
  <div ref="headerRef" class="w-full flex items-center justify-end bg-gray-100 rounded">
    <div class="mb-2 mt-1">
    <search-box
        :search-word="searchWord"
        :on-change="onSearchWordChange"
        :on-enter="onSearchWordEnter"
        place-holder="採用品名を入力"
    ></search-box>
    </div>
  </div>
  <div class="w-full">
    <custom-list
      ref="listOrderDefectRef"
      :table-fields="orderFields"
      :option-fields="orderOptionFields"
      :api-url="apis.pharmacy_stock_list"
      :is-checkable="true"
      :check-values="checkList"
      :height="listHeight + 'px'"
      :handler="handler"
      :on-check-change="onCheckChange"
      :dom-complete="domComplete"
    >
    <template v-slot:item="slotProps">
      <order-medicine-component
        :apis="apis"
        type="is_defect"
        :pharmacy-wholesalers="pharmacyWholesalers"
        :identity-id="slotProps.item.id"
        :item="slotProps.item"
        :fields="orderFields"
        :edit-transaction-status-change="editTransactionStatusChange"
        :edit-setting-complete="editSettingComplete"
      ></order-medicine-component>
    </template>
    </custom-list>
  </div>
  <div ref="submitRef" v-show="isEdited" class="fixed bottom-0 right-0 w-full flex items-center justify-end flex-wrap p-2 bg-gray-100 rounded">
    <div class="mr-2"><button type="button" @click="updatePharmacyDefectConfirm(true)" class="w-full py-2 px-2 text-xs font-medium text-white focus:outline-none bg-red-600 rounded-full border border-red-200 hover:bg-red-700 hover:text-white focus:z-10 focus:ring-4 focus:ring-red-200 dark:focus:ring-red-700 dark:bg-red-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mr-1">納品待ちに戻す</button></div>
    <div><button type="button" @click="updatePharmacyDefectConfirm()" class="w-full py-2 px-2 text-xs font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">削除確定</button></div>
  </div>

</div>
</template>

